module.exports = __webpack_public_path__ + "static/media/full_plan_bowl.40735826.jpg";